import { useStyledTheme } from '@openeducation/oe-it-themes';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';

import FeedbackResponse from './feedback-response';
import { Icon, OEButton, OEText } from '../../../atoms';

type FeedbackErrorProps = {
  onTryAgain: () => void;
};

export function FeedbackError({ onTryAgain }: FeedbackErrorProps) {
  const { t } = useTranslation();
  const { color } = useStyledTheme();

  return (
    <FeedbackResponse
      icon={
        <Icon
          type="solid"
          name="exclamation-triangle"
          size={40}
          color={color.error}
        />
      }
    >
      <OEText fontType="bold" style={styles.text}>
        {t('errors.unablePerformAction')}
      </OEText>
      <OEButton
        onPress={onTryAgain}
        style={{
          backgroundColor: color.grayLight,
        }}
        labelStyle={[
          styles.tryAgainButtonText,
          {
            color: color.error,
          },
        ]}
      >
        {t('mobile.feedback.reportBug.tryAgain')}
      </OEButton>
    </FeedbackResponse>
  );
}

const styles = StyleSheet.create({
  text: {
    paddingVertical: 30,
    paddingHorizontal: 20,
    textAlign: 'center',
    fontSize: 20,
  },
  tryAgainButtonText: {
    fontSize: 16,
  },
});
